var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip"},[_c('div',{staticClass:"tip-title"},[_vm._v("提示：")]),_c('div',[_vm._v("支持提交后再次编辑，访问路径：【企业运营中心】-【设置】-【基础信息设置】-【产品碳足迹信息】")])])
}]

export { render, staticRenderFns }